export enum BcheckType {
    Owner = "Owner",
    Spouse = "Spouse"
  }
  
  export const BcheckTypeLabel = new Map<BcheckType, string>([
    [BcheckType.Owner, "Cedente"],
    [BcheckType.Spouse, "Cônjuge"]
  ]);
  


// WEBPACK FOOTER //
// ./src/components/common/BcheckView/BcheckType.ts